/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import EmptyLayout from '@/views/layouts/EmptyLayout.vue';

export default [
    {
        path: 'catalog',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Konfiguracja kategorii
            {
                path: 'categories-configuration',
                name: 'catalog-categories-configurations',
                meta: { auth: true },
                component: () => import('@/modules/catalog/categories-configuration/views/CategoriesConfigurationList.vue')
            },
            {
                path: 'categories-configuration/add',
                name: 'catalog-categories-configuration-add',
                meta: { auth: true },
                component: () => import('@/modules/catalog/categories-configuration/views/CategoriesConfigurationForm.vue')
            },
            {
                path: 'categories-configuration/:id(\\d+)',
                name: 'catalog-categories-configuration-edit',
                meta: { auth: true },
                component: () => import('@/modules/catalog/categories-configuration/views/CategoriesConfigurationForm.vue')
            },
            // Zamówienia
            {
                path: 'orders',
                name: 'catalog-orders',
                meta: { auth: true },
                component: () => import('@/modules/catalog/orders/views/OrdersList.vue')
            },
            {
                path: 'orders/:id(\\d+)',
                name: 'catalog-orders-edit',
                meta: { auth: true },
                component: () => import('@/modules/catalog/orders/views/OrderForm.vue')
            },
            // Karty przedpłacone
            {
                path: 'prepaid-cards',
                name: 'catalog-prepaid-cards',
                meta: { auth: true },
                component: () => import('@/modules/catalog/prepaid-cards/views/PrepaidCardsList.vue')
            },
            {
                path: 'prepaid-cards/configuration',
                name: 'catalog-prepaid-cards-configuration',
                meta: { auth: true },
                component: () => import('@/modules/catalog/prepaid-cards/views/PerpaidCardConfiguration.vue')
            },
            {
                path: 'prepaid-cards/configuration-b2b',
                name: 'catalog-prepaid-cards-configuration-b2b',
                meta: { auth: true },
                component: () => import('@/modules/catalog/prepaid-cards/views/PerpaidCardConfigurationB2B.vue')
            }
        ]
    }
];
